export function handleRedirectUrlCheck(url) {
  if (url !== '/join' && url.substring(0, 12) !== '/findAccount') return true;
  else return false;
}
